// extracted by mini-css-extract-plugin
export default {"cc-footer":"lRYWeTqJ","cc-footer-container":"Cx5V_xJy","cc-footer-list":"HqB4sglz","cc-footer-link":"MvHmZEQX","cc-footer-copyright":"dvmNvwWq"};